<app-logic-transfer-form
  data-testid="logic-transfer-add-form-wrapper"
  #formWrapper
  [config]="config"
></app-logic-transfer-form>
